// extracted by mini-css-extract-plugin
module.exports = {"container":"text-intro_container__wsyp7","title":"text-intro_title__UwZ2a","description":"text-intro_description__zpIKl"};